import { render } from "./AccessData.vue?vue&type=template&id=5b108ca6"
import script from "./AccessData.vue?vue&type=script&lang=js"
export * from "./AccessData.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__